export default __webpack_public_path__ + "static/media/framer-motion.8930d787.png";